@let getGmaAlarmMarkerColorFnValue = getGmaAlarmMarkerColorFn();
@let showLayerSelectValue = showLayerSelect();
@let mapBoxConfigurationValue = mapBoxConfiguration();
@let styleValue = style();
@let boundsValue = bounds();
<mgl-map
  [style]="styleValue"
  [zoom]="mapBoxConfigurationValue.zoom"
  [maxZoom]="mapBoxConfigurationValue.maxZoom"
  [center]="mapBoxConfigurationValue.center"
  [fitBounds]="boundsValue"
  (mapCreate)="onMapCreated($event)"
  (mapLoad)="onMapLoad($event)">
  <mgl-control position="top-left">
    <button
      mat-mini-fab
      class="mgl-map__select-layer-button"
      data-testid="CLUSTER_HTML_BUTTON_SHOW_LAYER_SELECT"
      (click)="showLayerSelect.set(!showLayerSelectValue)">
      <fa-icon [icon]="['far', 'layer-group']"></fa-icon>
    </button>
  </mgl-control>
  <!--map layer select-->
  @if (showLayerSelectValue) {
    <mgl-control position="top-left">
      <button
        mat-icon-button
        (click)="showLayerSelect.set(false)"
        data-testid="CLUSTER_HTML_BUTTON_CLOSE_LAYER_SELECT">
        <fa-icon [icon]="['far', 'times']"></fa-icon>
      </button>
      <mat-card appearance="outlined" class="mgl-map__layer-select">
        <div class="mgl-map__layer-select-header">
          <div class="mgl-map__layer-select-header-text wm-subheading-2">
            {{ 'MAP.SELECT_BACKGROUND' | translate }}
          </div>
        </div>
        <mat-selection-list>
          @for (mapLayer of mapLayers(); track $index) {
            <mat-list-option
              [selected]="mapLayer.name === activeMapLayerName()"
              (click)="onSetActiveMapLayer(mapLayer.name)"
              role="option">
              <img
                [src]="
                  '/assets/images/map-background/' + mapLayer.name + '.png'
                "
                matListItemIcon />
              <div class="wm-subheading-2" matListItemLine>
                {{ 'MAP.' + mapLayer.name + '.TITLE' | translate }}
              </div>
              <p matListItemLine>
                {{ 'MAP.' + mapLayer.name + '.DESCRIPTION' | translate }}
              </p>
            </mat-list-option>
          }
        </mat-selection-list>
      </mat-card>
    </mgl-control>
  }

  <mgl-control
    mglNavigation
    [showZoom]="true"
    [showCompass]="false"></mgl-control>
  <mgl-control mglFullscreen></mgl-control>

  @for (tabParameter of tabParameters(); track tabParameter) {
    @let selectedParameterValue = selectedParameter();
    @if (tabParameter === selectedParameterValue) {
      @let filteredDataValue = filteredData();
      @if (tabParameter !== 'webcam') {
        @let mapParamatersConfigurationValue = mapParamatersConfiguration();
        <mgl-geojson-source
          [id]="mapParamatersConfigurationValue[tabParameter].clusterSourceId"
          [data]="filteredDataValue"
          [cluster]="true"
          [clusterRadius]="26"
          [clusterMaxZoom]="8"
          [clusterProperties]="
            mapParamatersConfigurationValue[tabParameter].clusterProperties
          "
          data-testid="CLUSTER_HTML_MGL_GEOJSON_SOURCE_ADD_SOURCE"></mgl-geojson-source>
        <mgl-markers-for-clusters
          [source]="
            mapParamatersConfigurationValue[tabParameter].clusterSourceId
          ">
          @let getMarkerColorClassFnValue = getMarkerColorClassFn();
          <ng-template mglClusterPoint let-feature>
            <app-cluster-point
              #clusterPointComponent
              [feature]="feature"
              [selectedParameter]="selectedParameterValue"
              [getGmaAlarmMarkerColorFn]="getGmaAlarmMarkerColorFnValue"
              [getMarkerColorClassFn]="getMarkerColorClassFnValue"
              (clickStation)="onClickStation($event)"></app-cluster-point>
          </ng-template>
          <ng-template mglPoint let-feature>
            <app-cluster-point
              [feature]="feature"
              [selectedParameter]="selectedParameterValue"
              [getGmaAlarmMarkerColorFn]="getGmaAlarmMarkerColorFnValue"
              [getMarkerColorClassFn]="getMarkerColorClassFnValue"
              (clickStation)="onClickStation($event)"></app-cluster-point>
          </ng-template>
        </mgl-markers-for-clusters>
      } @else {
        @for (feature of filteredDataValue.features; track $index) {
          @let webcamImagesValue = webcamImages();
          @if (webcamImagesValue[feature.properties.stationId] | isNil: false) {
            <mgl-marker [feature]="feature">
              <img
                mat-card-image
                [src]="webcamImagesValue[feature.properties.stationId]"
                alt="Webcam"
                class="mgl-map__webcam-marker"
                (click)="onClickStation(feature, $event)"
                data-testid="CLUSTER_HTML_IMG_WEBCAM" />
            </mgl-marker>
          }
        }
      }
    }
  }

  @let selectedStationValue = selectedStation();
  @if (selectedStationValue | isNil: false) {
    <mgl-popup
      [feature]="selectedStationValue"
      [closeButton]="true"
      (popupOpen)="flyTo(selectedStationValue.geometry.coordinates)"
      (popupClose)="selectedStation.set(null)"
      [anchor]="'center'"
      data-testid="CLUSTER_HTML_MGL_POPUP">
      <mat-card
        appearance="outlined"
        class="station-card-basic"
        style="margin: -10px">
        <ng-content select="[popup]"></ng-content>
      </mat-card>
    </mgl-popup>
  }
</mgl-map>

<ng-template #noData>
  <div class="mgl-map__marker-text">--</div>
</ng-template>

<ng-template #gmaAlarmValue let-value>
  <fa-layers size="lg">
    <fa-icon
      [icon]="['fas', 'triangle']"
      transform="down-2 left-2"
      [ngStyle]="{
        color: value | memoize: getGmaAlarmMarkerColorFnValue,
      }"></fa-icon>
    <fa-layers-text
      [content]="value"
      transform="down-5"
      size="sm"
      style="color: white"></fa-layers-text>
  </fa-layers>
</ng-template>
